interface Props {
  className?: string;
}
export const CashIcon = ({ className }: Props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g clipPath="url(#clip0_1004_2728)">
        <path
          d="M14.56 27.2H17.36V25.2C18.6933 24.96 19.84 24.44 20.8 23.64C21.76 22.84 22.24 21.6533 22.24 20.08C22.24 18.96 21.92 17.9333 21.28 17C20.64 16.0667 19.36 15.2533 17.44 14.56C15.84 14.0267 14.7333 13.56 14.12 13.16C13.5067 12.76 13.2 12.2133 13.2 11.52C13.2 10.8267 13.4467 10.28 13.94 9.88C14.4333 9.48 15.1467 9.28 16.08 9.28C16.9333 9.28 17.6 9.48667 18.08 9.9C18.56 10.3133 18.9067 10.8267 19.12 11.44L21.68 10.4C21.3867 9.46667 20.8467 8.65333 20.06 7.96C19.2733 7.26667 18.4 6.88 17.44 6.8V4.8H14.64V6.8C13.3067 7.09333 12.2667 7.68 11.52 8.56C10.7733 9.44 10.4 10.4267 10.4 11.52C10.4 12.7733 10.7667 13.7867 11.5 14.56C12.2333 15.3333 13.3867 16 14.96 16.56C16.64 17.1733 17.8067 17.72 18.46 18.2C19.1133 18.68 19.44 19.3067 19.44 20.08C19.44 20.96 19.1267 21.6067 18.5 22.02C17.8733 22.4333 17.12 22.64 16.24 22.64C15.36 22.64 14.58 22.3667 13.9 21.82C13.22 21.2733 12.72 20.4533 12.4 19.36L9.76 20.4C10.1333 21.68 10.7133 22.7133 11.5 23.5C12.2867 24.2867 13.3067 24.8267 14.56 25.12V27.2ZM16 32C13.7867 32 11.7067 31.58 9.76 30.74C7.81333 29.9 6.12 28.76 4.68 27.32C3.24 25.88 2.1 24.1867 1.26 22.24C0.42 20.2933 0 18.2133 0 16C0 13.7867 0.42 11.7067 1.26 9.76C2.1 7.81333 3.24 6.12 4.68 4.68C6.12 3.24 7.81333 2.1 9.76 1.26C11.7067 0.42 13.7867 0 16 0C18.2133 0 20.2933 0.42 22.24 1.26C24.1867 2.1 25.88 3.24 27.32 4.68C28.76 6.12 29.9 7.81333 30.74 9.76C31.58 11.7067 32 13.7867 32 16C32 18.2133 31.58 20.2933 30.74 22.24C29.9 24.1867 28.76 25.88 27.32 27.32C25.88 28.76 24.1867 29.9 22.24 30.74C20.2933 31.58 18.2133 32 16 32Z"
          fill="var(--swapper-primary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_1004_2728">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
